import { useTranslation } from 'react-i18next';

export function Terms() {
  const { t } = useTranslation();
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8" data-testid="header-terms">
        {t('route.terms.header')}
      </h1>
      <div className="rounded-2xl border border-gray-200 bg-white p-6 md:p-8 text-sm space-y-6">
        <p className="text-gray-700 leading-relaxed">{t('route.terms.p1')}</p>
        <p className="text-gray-700 leading-relaxed">
          {t('route.terms.p2')}{' '}
          <a
            href="https://www.bitkom.org/Bitkom/Ueber-uns"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline hover:opacity-80"
          >
            https://www.bitkom.org/Bitkom/Ueber-uns
          </a>
          ).
        </p>

        <div className="space-y-4 pt-2">
          <h2 className="font-semibold text-gray-900">
            {t('route.terms.download_heading', 'Vertragsbedingungen herunterladen')}
          </h2>
          <ul className="space-y-3">
            <li>
              <a
                href="https://dieterfilestorage.blob.core.windows.net/public/AGBs_SaaS_simply_legal.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:opacity-80"
              >
                {t('route.terms.a1')}
              </a>
            </li>
            <li>
              <a
                href="https://dieterfilestorage.blob.core.windows.net/public/AGBs_simply_legal.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:opacity-80"
              >
                {t('route.terms.a2')}
              </a>
            </li>
            <li>
              <a
                href="https://dieterfilestorage.blob.core.windows.net/public/Dieter%20Hauptvertrag.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:opacity-80"
              >
                {t('route.terms.a3')}
              </a>
            </li>
            <li>
              <a
                href="https://dieterfilestorage.blob.core.windows.net/public/Dieter%20Leistungsbeschreibung.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline hover:opacity-80"
              >
                {t('route.terms.a4')}
              </a>
            </li>
          </ul>
        </div>

        <p className="text-gray-400 text-xs pt-2">© simply Legal GmbH, Würzburg</p>
      </div>
    </div>
  );
}
